webpackJsonp([79813120194986],{

/***/ 164:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(40);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _digestModule = __webpack_require__(254);
	
	var _digestModule2 = _interopRequireDefault(_digestModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Digest = function Digest(_ref) {
	  var _ref$node = _ref.node,
	      path = _ref$node.path,
	      _ref$node$context = _ref$node.context,
	      index = _ref$node$context.index,
	      date = _ref$node$context.date,
	      title = _ref$node$context.title,
	      external = _ref$node$context.external;
	
	  var link = external ? _react2.default.createElement(
	    'a',
	    { target: '_blank', href: external },
	    title
	  ) : _react2.default.createElement(
	    _gatsbyLink2.default,
	    { to: path },
	    title
	  );
	
	  return _react2.default.createElement(
	    'div',
	    { key: index },
	    _react2.default.createElement(
	      'div',
	      null,
	      'Digest #',
	      index
	    ),
	    _react2.default.createElement(
	      'h5',
	      { className: _digestModule2.default.link },
	      link
	    ),
	    _react2.default.createElement(
	      'time',
	      null,
	      date
	    ),
	    _react2.default.createElement('hr', null)
	  );
	};
	
	var DigestPage = function DigestPage(_ref2) {
	  var edges = _ref2.data.allSitePage.edges;
	  return _react2.default.createElement(
	    'div',
	    { className: _digestModule2.default.digest },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Previous Digests'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Browse back issues of ML Review newsletter.'
	    ),
	    _react2.default.createElement('hr', null),
	    edges.map(Digest)
	  );
	};
	
	exports.default = DigestPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"digest":"src-pages----digest-module---digest---2DH0v","link":"src-pages----digest-module---link---28nfd"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-digest-js-e69cf561900bbe10963c.js